export default {
  'contact.eyebrow': "We're Here to Help",
  'contact.title': 'Contact Us',
  'contact.subtitle': "Tell us about your dream Vietnam journey. A local expert will get back to you within 24 hours to help craft a trip that's truly yours.",
  'contact.home': 'Home',
  'contact.contact': 'Contact',
  'contact.getInTouch': 'Get in touch directly',
  'contact.callUs': 'Call us',
  'contact.email': 'Email',
  'contact.headquarters': 'Headquarters',
  'contact.officeHours': 'Office hours',
  'contact.formTitle': 'Send us a message',
  'contact.interestedIn': "I'm interested in the tour:",
  'contact.formSubtitle': "Fill in the form and we'll reply as soon as possible.",
  'contact.fullName': 'Full name',
  'contact.phone': 'Phone',
  'contact.topic': 'Topic',
  'contact.message': 'Message',
  'contact.yourName': 'Your name',
  'contact.emailPlaceholder': 'you@example.com',
  'contact.phonePlaceholder': '+84 ...',
  'contact.messagePlaceholder': "Tell us about your travel plans, dates, and who's travelling...",
  'contact.topicGeneral': 'General inquiry',
  'contact.topicTailor': 'Tailor-made tour',
  'contact.topicBooking': 'Existing booking',
  'contact.topicPartnership': 'Partnership',
  'contact.topicFeedback': 'Feedback',
  'contact.sending': 'Sending...',
  'contact.send': 'Send message',
  'contact.success': 'Thank you! Your message has been sent. A local expert will get back to you shortly.',
  'contact.errorGeneric': 'Something went wrong. Please try again later.',
  'contact.errorNetwork': 'A network error occurred. Please check your connection and try again.',
  'contact.address': 'No. 10/2, Lane 29, Alley 264, To 13, Bo De Ward, Hanoi',
  'contact.hours': 'Mon – Sat, 8:00 AM – 6:00 PM (GMT+7)',
  'contact.heroAlt': 'Contact Vietnam Travel',
  'contact.mapTitle': 'Vietnam Travel headquarters location',
  'contact.captchaRequired': 'Please confirm you are not a robot.',
  'contact.captchaFailed': 'Security verification failed. Please try again.',
};